{
  "columns": [],
  "buttons": [],
  "apiDetails": "mass-adjustment-list.json",
  "pageName": "timeSheetAuthAdjustmentBatchResultList",
  "orderByColumn": ["modifiedDate"],
  "orderBy": ["desc"]
}
